import { Button, Col, Form, Input, Modal, Row, Switch } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { onChange, onLoadChannel, onOk, onSaveChannel, onVerifyChannel, onConnectAmazonFailure } from './../../../actions/settingChannelAction';
import Header from './../../../components/header';
import SideBar from './../../../components/sidebar-setting';
import { setHeight, titleHead } from './../../../services/helper';
import { getChannel } from './../../../utils/settingChannel';
import { getOAuthRedirectUrl } from './../../../utils/settingOAuth';
import ChannelTable from './components/channel-table';
import { permissions } from './../../../constants'
import handlePermission from './../../app/handlePermission';
import { ListChannel } from './../../../constants/setting_channel';
import { listChannel } from "./../../../utils/channel";
import lang from "./../../../languages/en";
import { alertError } from '../../../services/dialog';
import './styles.css';
import { Fragment } from 'react';
import history from '../../../services/history';
import { toTransmitedShipmentSuccess } from '../../../actions/shipmentAction';

const FormItem = Form.Item;


class SettingChannel extends Component {
    constructor(props) {
        super(props)
        this.state = {
            disabled: !handlePermission(permissions.EcCredentialSaveSetting) ? true : false,
            currentChannel: ListChannel.AMAZON_JP.ShortName,
            currentChannelId: '',
            listChannel: []
        }
    }

    componentDidMount = () => {
        titleHead('Setting Channel')

        // Set the same height for three column
        setHeight()
        // Set the same height for three column when resize window
        window.addEventListener('resize', this.updateDimensions)

        let _this = this

        listChannel().then(res => {
            if (res.data.code === 10001) {
                if (res.data.data.channels.length > 0) {
                    let dataFirstChannel = res.data.data.channels[0];
                    if (dataFirstChannel.ShortName != ListChannel.Y_SHIP.ShortName) {
                        _this.setState({
                            listChannel: res.data.data.channels,
                            currentChannel: dataFirstChannel.ShortName
                        })
                        _this.setCurrentChannelId(dataFirstChannel.ShortName);
                    }
                }

            } else {

            }
        })
    }

    setCurrentChannelId(currentChannel) {
        let _this = this;
        _this.state.listChannel.forEach((item, key) => {
            if (item && item.ShortName == currentChannel) {
                _this.setState({
                    currentChannelId: item.ID
                })
            }
        });
    }
    updateDimensions() {
        setHeight()
    }

    handleChange = (e, column, val) => {
        var english = /^[0-9A-Za-z!@#%&*()+:""\-;',.\/_ ]*$/
        if (english.test(e.target.value)) {
            this.props.onChange({
                value: e.target.value,
                column: column
            })
        }
    }

    handleChangeCurrentChannel = (currentChannel) => {
        this.setCurrentChannelId(currentChannel);
        this.setState({
            currentChannel: currentChannel
        });
    }
    cancel = () => {
        // Set the same height for three column
        setHeight()
        // Set the same height for three column when resize window
        window.addEventListener('resize', setHeight())

        this.loadChannel();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.currentChannelId !== this.state.currentChannelId) {
            this.loadChannel();
        }
    }

    loadChannel() {
        let _this = this
        let request = {
            channel_id: _this.state.currentChannelId
        }
        getChannel(request).then(channel => {
            _this.props.onLoadChannel({
                channel_id: _this.state.currentChannelId,
                seller_id: (channel.data.data.SellerId) ? channel.data.data.SellerId : '',
                auth_token: (channel.data.data.AuthToken) ? channel.data.data.AuthToken : '',
                refresh_token: (channel.data.data.RefreshToken) ? channel.data.data.RefreshToken : '',
            })
        })
    }

    getOAuthRedirectUrl() {
        let _this = this;
        let request = {
            channel_id: _this.state.currentChannelId
        }
        getOAuthRedirectUrl(request)
            .then(response => {
                if (response.status === 200) {
                    if (response.data.data.RedirectUrl) {
                        window.location.href = response.data.data.RedirectUrl;
                    }
                } else {
                    this.props.onConnectAmazonFailure();
                }
            })
            .catch((err) => {
                this.props.onConnectAmazonFailure();
            })
    }

    showVerifyButton() {
        if (this.state.currentChannel !== ListChannel.AMAZON_JP.ShortName) {
            return (
                <Button
                    className="verify-btn ant-btn-primary"
                    loading={this.props.loading_verify}
                    onClick={() => this.validateForm()}
                    disabled={this.state.disabled}
                >
                    Verify Channel Credentials
                </Button>
            );
        }
    }

    oauthButton() {
        if (this.state.currentChannel === ListChannel.AMAZON_JP.ShortName) {
            return (
                <Button
                    className="oauth-btn"
                    loading={this.props.loading_verify}
                    onClick={() => this.getOAuthRedirectUrl()}
                    disabled={this.state.disabled}
                >
                    Connect to Amazon
                </Button>
            );
        } else {
            return (
                <Fragment />
            );
        }
    }

    /**
     * Channel Amazon use OAuth to authorize account and save credential if OAuth success
     * @returns 
     */
    showFooter() {
        if (this.state.currentChannel !== ListChannel.AMAZON_JP.ShortName) {
            return (
                <Row className="footer-component">
                    <div className="fix-footer">
                        <Button className="cancel" onClick={this.cancel} disabled={this.state.disabled}>
                            Cancel
                        </Button>
                        <Button
                            disabled={(this.props.verify_success ? false : true) || this.state.disabled}
                            className={(this.props.verify_success ? 'active-button-save-setting-channel' : '') + " save ant-btn-primary"}
                            loading={this.props.loading_save}
                            onClick={() => this.props.onSaveChannel(this.props.input_channel)}
                        >
                            Save
                        </Button>
                    </div>
                </Row>
            );
        }
    }

    getCurrentLabel() {
        let key;
        let list_label = {
            "seller_id": "",
            "auth_token": "",
            "refresh_token": ""
        }
        for (key in ListChannel) {
            if (ListChannel[key].ShortName === this.state.currentChannel) {
                list_label = ListChannel[key].Label;
                break;
            }
        }
        return list_label;
    }

    validateForm() {
        switch (this.state.currentChannel) {
            case ListChannel.RAKUTEN.ShortName:
                if (!this.props.input_channel.seller_id.trim()) {
                    alertError(lang.rakuten_service_secret_empty);
                    return null;
                } else if (!this.props.input_channel.auth_token.trim()) {
                    alertError(lang.rakuten_license_key_empty);
                    return null;
                }
                break
            default:
                if (!this.props.input_channel.seller_id.trim()) {
                    alertError(lang.amazon_seller_id_empty);
                    return null;
                } else if (!this.props.input_channel.auth_token.trim()) {
                    alertError(lang.aws_auth_token_empty);
                    return null;
                }
        }

        this.props.onVerifyChannel(this.props.input_channel);
    }

    /**
     * Check if use has refresh token
     */
    isConnected() {
        return this.props.input_channel.refresh_token !== undefined && this.props.input_channel.refresh_token !== '';
    }

    /**
     * 
     * @returns Show connect sataus if channel is Amazon and having refresh token
     */
    showConnectStatus() {
        if (this.state.currentChannel === ListChannel.AMAZON_JP.ShortName) {
            return (
                <FormItem label="Connection Status">
                    {this.props.input_channel.refresh_token ? '🟢 Online' : '🔴 Offline'}
                </FormItem>
            );
        }
    }

    render() {
        let list_label = this.getCurrentLabel();
        return (
            <div id="setting-channel">
                <Modal
                    visible={this.props.verify_success_visible}
                    closable={false}
                    footer={[
                        <Button key="ok_modal_verify_success" type="primary" onClick={this.props.onOk}>
                            OK
                        </Button>,
                    ]}
                >
                    <p>Channel credentials verified.</p>
                </Modal>
                <Modal
                    visible={this.props.verify_failure_visible}
                    closable={false}
                    footer={[
                        <Button key="ok_modal_verify_failure" type="primary" onClick={this.props.onOk}>
                            OK
                        </Button>,
                    ]}
                >
                    <p>Channel credentials could not be verified.<br></br><br></br>
                        Please check your channel credentials and try again.</p>
                </Modal>
                <Modal
                    visible={this.props.save_success_visible}
                    closable={false}
                    footer={[
                        <Button key="ok_modal_save_success" type="primary" onClick={this.props.onOk}>
                            OK
                        </Button>,
                    ]}
                >
                    <p>Channel credentials saved.</p>
                </Modal>
                <Modal
                    visible={this.props.save_failure_visible}
                    closable={false}
                    footer={[
                        <Button key="ok_modal_save_failure" type="primary" onClick={this.props.onOk}>
                            OK
                        </Button>,
                    ]}
                >
                    <p>Save Failure!</p>
                </Modal>
                <Modal
                    visible={this.props.connect_amazon_failure_visible}
                    closable={false}
                    footer={[
                        <Button key="ok_modal_connect_amazon_failure" type="primary" onClick={this.props.onOk}>
                            OK
                        </Button>,
                    ]}
                >
                    <p>Connect Failure!</p>
                </Modal>
                <Header />
                <div className="content">
                    <Row>
                        <Col id="setting-left" className="left-col" span={3}>
                            <SideBar />
                        </Col>
                        <Col id="setting-center" className="left-col" span={9}>
                            <ChannelTable currentChannel={this.state.currentChannel} listChannel={this.state.listChannel} onChangeCurrentChannel={this.handleChangeCurrentChannel} />
                        </Col>
                        <Col id="setting-right" className="right-col" span={12}>
                            <div className="verify" id="setting-amazon-jp">
                                {this.showVerifyButton()}
                                {this.oauthButton()}
                                <Form layout="vertical">
                                    {this.showConnectStatus()}
                                    <FormItem label={list_label.seller_id}>
                                        <Input.Password
                                            placeholder="99999999999"
                                            value={this.props.input_channel.seller_id}
                                            onChange={e => this.handleChange(e, 'seller_id', this.props.input_channel.seller_id)}
                                            disabled={this.state.disabled}
                                        />
                                    </FormItem>
                                    <FormItem label={list_label.auth_token}>
                                        <Input.Password
                                            placeholder="99999999999"
                                            value={this.props.input_channel.auth_token}
                                            onChange={e => this.handleChange(e, 'auth_token', this.props.input_channel.auth_token)}
                                            disabled={this.state.disabled}
                                        />
                                    </FormItem>
                                </Form>
                            </div>
                            {this.showFooter()}
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        input_channel: state.settingChannelReducer.input_channel,
        loading_verify: state.settingChannelReducer.loading_verify,
        loading_save: state.settingChannelReducer.loading_save,
        verify_failure: state.settingChannelReducer.verify_failure,
        verify_success: state.settingChannelReducer.verify_success,
        verify_failure_visible: state.settingChannelReducer.verify_failure_visible,
        verify_success_visible: state.settingChannelReducer.verify_success_visible,
        save_failure_visible: state.settingChannelReducer.save_failure_visible,
        save_success_visible: state.settingChannelReducer.save_success_visible,
        connect_amazon_failure_visible: state.settingChannelReducer.connect_amazon_failure_visible,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onOk: () => {
            dispatch(onOk())
        },
        onChange: payload => {
            dispatch(onChange(payload))
        },
        onVerifyChannel: payload => {
            dispatch(onVerifyChannel(payload))
        },
        onSaveChannel: payload => {
            dispatch(onSaveChannel(payload))
        },
        onLoadChannel: payload => {
            dispatch(onLoadChannel(payload))
        },
        onConnectAmazonFailure: payload => {
            dispatch(onConnectAmazonFailure(payload))
        }
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SettingChannel)


// WEBPACK FOOTER //
// ./src/containers/setting/setting-channel/index.js